import React from 'react';
import { FileDown, FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DownloadsPage = () => {
  const navigate = useNavigate();

  const documents = [
    {
      id: 1,
      name: 'Healthcare General Contracting Capabilities Statement',
      filename: 'healthcare_contracting_capabilities_statement.pdf',
      description: '4-page brochure showcasing our electrical, plumbing, and HVAC capabilities for healthcare facilities.',
      size: '907 KB',
      type: 'PDF'
    }
  ];

  const handleDownload = (filename) => {
    const downloadUrl = `${API_URL}/api/documents/${filename}`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-white">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 mb-8 transition-colors"
          data-testid="back-button"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>

        <h1 className="text-3xl font-bold mb-2" data-testid="downloads-title">Downloads</h1>
        <p className="text-slate-400 mb-8">Access our brochures, capabilities statements, and documentation.</p>

        {/* Documents List */}
        <div className="space-y-4">
          {documents.map((doc) => (
            <div 
              key={doc.id}
              className="bg-slate-800/50 border border-slate-700 rounded-lg p-6 hover:border-cyan-500/50 transition-all"
              data-testid={`document-card-${doc.id}`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-cyan-500/10 rounded-lg">
                    <FileText className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1">{doc.name}</h3>
                    <p className="text-slate-400 text-sm mb-2">{doc.description}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                      <span className="bg-slate-700 px-2 py-1 rounded">{doc.type}</span>
                      <span>{doc.size}</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => handleDownload(doc.filename)}
                  className="flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-medium px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
                  data-testid={`download-btn-${doc.id}`}
                >
                  <FileDown className="w-4 h-4" />
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Direct Link Section */}
        <div className="mt-8 p-4 bg-slate-800/30 border border-slate-700 rounded-lg">
          <p className="text-sm text-slate-400 mb-2">Direct download link:</p>
          <code className="text-xs text-cyan-400 break-all block bg-slate-900 p-2 rounded">
            {API_URL}/api/documents/healthcare_contracting_capabilities_statement.pdf
          </code>
        </div>
      </div>
    </div>
  );
};

export default DownloadsPage;
